import { render, staticRenderFns } from "./DemoPhoto.vue?vue&type=template&id=18909d91&scoped=true&"
import script from "./DemoPhoto.vue?vue&type=script&lang=js&"
export * from "./DemoPhoto.vue?vue&type=script&lang=js&"
import style0 from "./DemoPhoto.vue?vue&type=style&index=0&id=18909d91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18909d91",
  null
  
)

export default component.exports